import api from './api'

export default {
  all() {
    return api.get('/partner-licensings/:partnerLicensingId/clinical-care-priorities/all')
  },
  list(params = {}) {
    return api.get('/partner-licensings/:partnerLicensingId/clinical-care-priorities', { params })
  },
  create(body) {
    return api.post('/partner-licensings/:partnerLicensingId/clinical-care-priorities', body)
  },
  update(id, body) {
    return api.put(`/partner-licensings/:partnerLicensingId/clinical-care-priorities/${id}`, body)
  },
  destroy(id) {
    return api.delete(`/partner-licensings/:partnerLicensingId/clinical-care-priorities/${id}`)
  },
}
